<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    //禁止鼠标右键
    document.oncontextmenu = new Function("event.returnValue=false;");
    document.onselectstart = new Function("event.returnValue=false;");
    //禁用按键
    document.onkeydown = function () {
      if (
        event.ctrlKey ||
        event.code == "Escape" ||
        event.code == "F5" ||
        event.code == "F11" ||
        event.code == "F12"
      ) {
        return false;
      }
    };
  },
};
</script>

<style>
#app,
body,
html {
  width: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #1f2937;
}

article,
aside,
blockquote,
body,
button,
dd,
details,
div,
dl,
dt,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
hr,
input,
legend,
li,
menu,
nav,
ol,
p,
section,
td,
textarea,
th,
ul {
  padding: 0;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/App.vue